import React from 'react';
import { SectionHeader } from '../components/UI';
import { useInView } from '../hooks/useInView';
import { PAIN_POINTS } from '../data/courseData';
import styles from './Problem.module.css';

export default function Problem() {
  const [ref, inView] = useInView();

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <SectionHeader
          label="The Real Problem"
          title="Most digital marketing courses leave you<br /><span style='color:#ff8c66'>theory-heavy and job-ready for nothing.</span>"
          subtitle="You've probably seen courses that promise everything — then dump 300 videos on you with zero real campaign experience."
          light
          center
        />
        <div className={styles.grid} ref={ref}>
          {PAIN_POINTS.map((p, i) => (
            <div
              key={i}
              className={`${styles.card} ${inView ? styles.visible : ''}`}
              style={{ transitionDelay: `${i * 0.09}s` }}
            >
              <div className={styles.emoji}>{p.emoji}</div>
              <h3 className={styles.cardTitle}>{p.title}</h3>
              <p className={styles.cardDesc}>{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
